// @flow
import type {Node} from 'react'
import React, {useCallback} from 'react'
import {Draggable} from 'react-beautiful-dnd'

type Props = {
  index: number,
  draggableId: string,
  disableInteractiveElementBlocking: boolean,
  children: Node | (props: Object) => Node,
}

function DraggableItem({
  index,
  draggableId,
  disableInteractiveElementBlocking,
  children,
}: Props): Node {
  const renderDefault = useCallback((props) => (
    <div {...props}>
      {typeof children === 'function' ? children(props) : children}
    </div>
  ), [children])

  const renderFunction = useCallback((provided) => (
    (typeof children === 'function' ? children : renderDefault)({
      ref: provided.innerRef,
      ...provided.draggableProps,
      ...provided.dragHandleProps,
    })
  ), [children, renderDefault])

  return (
    <Draggable
      draggableId={draggableId}
      index={index}
      disableInteractiveElementBlocking={disableInteractiveElementBlocking}
    >
      {renderFunction}
    </Draggable>
  )
}

DraggableItem.defaultProps = {
  disableInteractiveElementBlocking: false,
}

export default DraggableItem
